<div class="mainContent">
  <div class="pageHeader" i18n>User Info</div>
  <div class="userInfo">
    <mat-card class="userCard">
      <mat-card-header>
        <mat-card-title class="actionButton">
          <button mat-button i18n-matTooltip matTooltip="Set permissions" (click)="setUserPermissions()">
            <mat-icon>display_settings</mat-icon>
          </button>
          <button mat-button i18n-matTooltip matTooltip="Lock user" [disabled]="isLockEnabled === false" (click)="userStatusChange()" *ngIf="selectedUser && selectedUser.lock===0">
            <mat-icon>lock</mat-icon>
          </button>
          <button mat-button i18n-matTooltip matTooltip="Unlock user" (click)="userStatusChange()" *ngIf="selectedUser && selectedUser.lock===1">
            <mat-icon class="material-icons color_red">lock</mat-icon>
          </button>
          <button mat-button i18n-matTooltip matTooltip="Delete User" *ngIf ="showDelete" (click)="deleteUser(selectedUser.id)">
            <mat-icon>delete</mat-icon>
          </button>
        </mat-card-title>
        <mat-card-title i18n>Details</mat-card-title>
        <mat-card-subtitle i18n>
          Login information
        </mat-card-subtitle>
      </mat-card-header>

      <mat-card-content>
            <mat-list class="itemDetails">
              <div mat-line>
                <mat-list-item i18n class="itemQuestion"> ID </mat-list-item>
                <mat-list-item role="listitem" *ngIf="selectedUser" class="itemAnswer"> {{selectedUser.id}}</mat-list-item>
              </div>
              <div mat-line>
                <mat-list-item i18n class="itemQuestion"> Name </mat-list-item>
                <mat-list-item role="listitem" *ngIf="selectedUser" class="itemAnswer"> {{selectedUser.name}}</mat-list-item>
              </div>
              <div mat-line>
                <mat-list-item i18n class="itemQuestion"> Status </mat-list-item>
                <mat-list-item role="listitem" *ngIf="selectedUser" class="itemAnswer"> {{selectedUser.status}}</mat-list-item>
              </div>
              <div mat-line>
                <mat-list-item i18n class="itemQuestion"> LastLoggedIn </mat-list-item>
                <mat-list-item role="listitem" *ngIf="selectedUser" class="itemAnswer"> {{selectedUser.lastLoggedIn}}</mat-list-item>
              </div>
              <div mat-line>
                <mat-list-item i18n class="itemQuestion"> Last LoggedIn Device </mat-list-item>
                <mat-list-item role="listitem" *ngIf="selectedUser" class="itemAnswer"> {{selectedUser.lastDevice}}</mat-list-item>
              </div>
              <div mat-line>
                <mat-list-item i18n class="itemQuestion"> Redlinings </mat-list-item>
                <mat-list-item role="listitem" *ngIf="selectedUser" class="itemAnswer"> {{selectedUser.redlinings}} </mat-list-item>
              </div>
            </mat-list>
      </mat-card-content>
    </mat-card>

    <div class="userQRCard">
      <mat-card>
        <mat-card-header>
          <mat-card-title class="actionButton">
            <button mat-button i18n-matTooltip matTooltip="Copy Activation Code" [cdkCopyToClipboard]="qrRegistrationCode" *ngIf="hasAccess && selectedUserProfile" (click)="qrCopy()">
              <mat-icon>content_copy</mat-icon>
            </button>
            <button mat-button i18n-matTooltip matTooltip="Send Email"
              *ngIf="hasAccess && selectedUserProfile" (click)="sendNotification()">
              <mat-icon class="qr">share</mat-icon>
            </button>
          </mat-card-title>
          <mat-card-title i18n>Authentication</mat-card-title>
          <mat-card-subtitle i18n>
            User registration details
          </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <div class="rowContent" *ngIf="qrInfoDisplay">
            <div class="qrCodeBox">
              <qrcode [qrdata]="qrRegistrationCode" [width]="256"
                [errorCorrectionLevel]="'M'" />
            </div>

            <div *ngIf="hasAccess" class="infoBox">
              <mat-list *ngIf="selectedUserProfile">
                <div mat-line class="userNameInfo">
                  <div>
                    <mat-list-item i18n class="qrQuestion"> User </mat-list-item>
                    <mat-list-item class="qrAnswer">{{qrrawValue.cSUser}} </mat-list-item>

                    <mat-list-item class="qrQuestion"> IP </mat-list-item>
                    <mat-list-item class="qrAnswer">{{qrrawValue.Server}} </mat-list-item>

                    <mat-list-item class="qrQuestion"> MapCacheID </mat-list-item>
                    <mat-list-item role="listitem" class="qrAnswer"> {{qrrawValue.MapCacheId}}</mat-list-item>
                  </div>

                  <div>
                    <mat-list-item class="qrQuestion"> Hostname </mat-list-item>
                    <mat-list-item role="listitem" class="qrAnswer"> {{hostname}}</mat-list-item>

                    <mat-list-item class="qrQuestion"> Port </mat-list-item>
                    <mat-list-item role="listitem" class="qrAnswer"> {{qrrawValue.Port}}</mat-list-item>

                    <mat-list-item class="qrQuestion"> MapCacheName </mat-list-item>
                    <mat-list-item role="listitem" class="qrAnswer"> {{qrrawValue.MapCacheName}}</mat-list-item>
                  </div>
                </div>
              </mat-list>
            </div>
          </div>
        </mat-card-content>
      </mat-card>

      <mat-card class="regionCard">
        <mat-card-header>
          <mat-card-title class="actionButton">
            <button mat-button i18n-matTooltip matTooltip="Regions" *ngIf="assignedRegions.length !== 0" [matMenuTriggerFor]="menu">
              <mat-icon>info</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item *ngFor="let reg of assignedRegions">{{reg.name}}</button>
            </mat-menu>
          </mat-card-title>
          <mat-card-title i18n>Assigned Regions</mat-card-title>
          <mat-card-subtitle i18n>
            Regions assigned to the user
          </mat-card-subtitle>
        </mat-card-header>

        <mat-card-content>
          <mat-list>
            <div mat-line>
              <mat-list-item i18n class="qrQuestion"> No. of regions </mat-list-item>
              <mat-list-item class="qrAnswer">{{assignedRegions.length}}</mat-list-item>
            </div>
          </mat-list>
        </mat-card-content>
      </mat-card>
    </div>

    <mat-card class="userCard">
      <mat-card-header>
        <mat-card-title class="actionButton" *ngIf="hasAccess">
          <button mat-button i18n-matTooltip matTooltip="Add Profile"
            *ngIf="!selectedUserProfile" (click)="addUserProfile()">
            <mat-icon class="addProfile">add</mat-icon>
          </button>
          <button mat-button i18n-matTooltip matTooltip="Edit Profile" [disabled]="isEditEnabled === false"
            *ngIf="selectedUserProfile" (click)="editUserProfile()">
            <mat-icon class="editProfile">edit</mat-icon>
          </button>
          <button mat-button i18n-matTooltip matTooltip="Reset Password" [disabled]="isPasswordResetEnabled === false"
            *ngIf="selectedUserProfile" (click)="updatePassword()">
            <mat-icon class="editProfile">lock_reset</mat-icon>
          </button>
        </mat-card-title>
        <mat-card-title i18n>Profile</mat-card-title>
        <mat-card-subtitle i18n>
          User basic details
        </mat-card-subtitle>
      </mat-card-header>

      <mat-card-content>
        <mat-list class="itemDetails" *ngIf="selectedUserProfile">
          <div mat-line>
            <mat-list-item i18n class="itemQuestion"> ID </mat-list-item>
            <mat-list-item *ngIf="selectedUserProfile" class="itemAnswer">{{selectedUserProfile.id}} </mat-list-item>
          </div>
          <div mat-line>
            <mat-list-item i18n class="itemQuestion"> FirstName </mat-list-item>
            <mat-list-item role="listitem" *ngIf="selectedUserProfile" class="itemAnswer"> {{selectedUserProfile.firstName}}</mat-list-item>
          </div>
          <div mat-line>
            <mat-list-item i18n class="itemQuestion"> LastName </mat-list-item>
            <mat-list-item role="listitem" *ngIf="selectedUserProfile" class="itemAnswer"> {{selectedUserProfile.lastName}}</mat-list-item>
          </div>
          <div mat-line>
            <mat-list-item i18n class="itemQuestion"> Role </mat-list-item>
            <mat-list-item role="listitem" *ngIf="selectedUserProfile" class="itemAnswer"> {{selectedUser.role}}</mat-list-item>
          </div>
          <div mat-line>
            <mat-list-item i18n class="itemQuestion"> Email </mat-list-item>
            <mat-list-item role="listitem" *ngIf="selectedUserProfile" class="itemAnswer"> {{selectedUserProfile.email}}</mat-list-item>
          </div>
          <div mat-line>
            <mat-list-item i18n class="itemQuestion"> Company </mat-list-item>
            <mat-list-item role="listitem" *ngIf="selectedUserProfile" class="itemAnswer"> {{selectedUserProfile.company}}</mat-list-item>
          </div>
        </mat-list>
      </mat-card-content>
    </mat-card>
  </div>
</div>
